import React, { useState } from 'react';
import { Modal, Select, Spin, Button } from 'antd';
import { UseGetQaqcRfiForms } from '../../hooks/genericHooks';
import { getAnchoredModalStyle } from './modalPositioning';

// Accept unified dynamic modal props
interface QaQcRfiSelectProps {
  open: boolean;
  value?: any;
  onOk: (value: any) => void;
  onCancel: () => void;
  afterClose?: () => void;
  anchorRect?: DOMRect | null;
  options?: any[];
}

const QaQcRfiSelect: React.FC<QaQcRfiSelectProps> = ({ open, value, onOk, onCancel, afterClose, anchorRect }) => {
  const { data: rfiData, isLoading: rfiLoading } = UseGetQaqcRfiForms();
  const [selectedId, setSelectedId] = useState<string | number | null>(value ?? null);

  const modalWidth = 520;

  // Keep internal state in sync with prop
  React.useEffect(() => {
    setSelectedId(value ?? null);
  }, [value]);

  return (
    <Modal
      open={open}
      title="Select RFI"
      closable={true}
      getContainer={false}
      centered={!anchorRect}
      style={anchorRect ? getAnchoredModalStyle(anchorRect, { width: modalWidth }) : undefined}
      afterClose={afterClose}
      footer={[
        <Button key="cancel" onClick={onCancel}>Cancel</Button>,
        <Button key="ok" type="primary" onClick={() => {
          const selectedRfi = (rfiData?.data || []).find((rfi: any) => rfi.id === selectedId);
          if (selectedRfi) onOk(`${selectedRfi.form_id} - ${selectedRfi.rfi_subject || ''}`);
        }} disabled={!selectedId}>Select</Button>
      ]}
      destroyOnClose
      onCancel={onCancel}
    >
      <Spin spinning={rfiLoading}>
        <Select
          showSearch
          style={{ width: '100%', borderRadius: 0, background: '#e6f2ff', border: 'none' }}
          placeholder="Select an RFI"
          value={selectedId ?? undefined}
          onChange={setSelectedId}
          optionFilterProp="children"
          dropdownStyle={{ borderRadius: 0 }}
          filterOption={(input, option) =>
            String(option?.children).toLowerCase().includes(input.toLowerCase())
          }
        >
          {(rfiData?.data || []).map((rfi: any) => (
            <Select.Option key={rfi.id} value={rfi.id}>
              {`${rfi.form_id} - ${rfi.rfi_subject || `RFI ${rfi.id}`}`}
            </Select.Option>
          ))}
        </Select>
      </Spin>
    </Modal>
  );
};

export default QaQcRfiSelect;
